<template>
  <div class="menuTab1">
    <div class="botonera">
      <el-row :gutter="0">
        <el-col :sm="24" :offset="0">
          <!-- <el-button icon="el-icon-arrow-left" type="pink" size="mini" style="width:25%" @click="selectMenu('volver')" >Volver</el-button> -->
          <!-- <el-button type="pink" size="mini" style="width:25%" :class="{'is-active': activeBtn === 'guia' }"  @click="selectMenu('guia')" >Guía</el-button> -->
          <el-button type="pink" size="mini" style="width: 25%; height:40px"
            :class="{ 'is-active': activeBtn === 'pedido' }" @click="selectMenu('pedido')">
            <i class="icon-cart"></i> Pedido
          </el-button>
          <el-button type="pink" size="mini" style="width: 25%; height:40px"
            :class="{ 'is-active': activeBtn === 'productos' }" @click="selectMenu('productos')">
            <i class="icon-detalle"></i>
            Productos</el-button>
          <el-button type="pink" size="mini" style="width: 25%; height:40px"
            :class="{ 'is-active': activeBtn === 'pago' }" @click="selectMenu('pago')">
            <i class="icon-card"></i>
            Pago</el-button>
          <el-button type="pink" size="mini" style="width: 25%; height:40px"
            :class="{ 'is-active': activeBtn === 'entrega' }" @click="selectMenu('entrega')">
            <i class="icon-pdr3"></i>Entrega</el-button>
          <!-- <el-button type="pink" size="mini" style="width:25%" >Seller</el-button> -->
          <!-- <el-button icon="el-icon-full-screen" type="pink" size="mini" style="width:25%" ></el-button> -->
        </el-col>
        <el-col :sm="8"></el-col>
      </el-row>
    </div>
    <el-row :gutter="0">
      <el-col :sm="24" v-if="!isMobile">

        <Pedido :datos="datos" v-if="activeBtn === 'pedido'"></Pedido>
        <DataVtex :datos="datos" v-if="activeBtn === 'productos'" />
        <Pago :datos="datos" v-if="activeBtn === 'pago'" />
        <Entrega :datos="datos" v-if="activeBtn === 'entrega'" />
      </el-col>

    </el-row>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
import { cerrarModalDesdeIframe } from "@/helpers/helpers.js";
import estadosMixins from "@/mixins/estadosMixins.js";
import Pedido from "@/components/Pedido.vue";
// import Motivos from "@/components/motivos.vue";
// import EnEspera from "@/components/EnEspera.vue";
import DataVtex from "@/components/dataVtex2.vue";
import Pago from "@/components/Pago.vue";
import Entrega from "@/components/Entrega.vue";
// import CommentSection from "@/components/commentSection.vue";
export default {
  props: ["datos"],
  mixins: [estadosMixins],
  name: "datosSection",
  components: {
    Pedido,
    // Motivos,
    // EnEspera,
    DataVtex,
    Pago,
    Entrega,
    // CommentSection,

  },
  watch: {
    $route(to, from) {
      if (to.params.pedido != from.params.pedido) {
        this.pedido = to.params.pedido;
      }
    },
    datos: function (newVal, oldVal) { // watch it
      this.datos = newVal;
    }
  },

  data() {
    return {
      isMobile: false,
      activeBtn: "pedido",
      reclamo: false,
      idwc: 0,
      abriChat: false,
      datosWc: {},
      mostrarVolver: false
    };
  },
  created() {
    this.getArrepentido1();
    EventBus.$on("goToMenu", (menu) => {
      this.activeBtn = menu;
    });
    EventBus.$on("abriChat", (datosWc) => {
      this.datosWc = datosWc
      this.abriChat = datosWc;
      this.mostrarVolver = false;

      console.log("abriChat");
    });

    EventBus.$on('regresarAlPedido', () => {
      this.isMobile = false;
      this.mostrarVolver = true;
      console.log('regresarAlPedido');
      cerrarModalDesdeIframe();
      console.log('regresarAlPedido detalle');
    });
    EventBus.$on("procesarArrepentimiento", (res) => {
      console.log("procesarArrepentimiento", res);
      if (res.reclamo.reclamo) {
        this.datos.datos_reclamo = res.reclamo.reclamo;
        this.datos.reclamo = res.reclamo.reclamo ? res.reclamo.reclamo[0].id : 0;

      }
      else {
        this.$alert("No pudimos procesar el reclamo, refresque la página y reintente", "Error", {
          confirmButtonText: "Aceptar",

        });
      }
      setTimeout(() => {
        this.getArrepentido1();
      }, 100);

    });
  },
  methods: {
    getArrepentido1() {
      if (
        this.datos.datos_reclamo &&
        this.datos.datos_reclamo.length &&
        [2, 3, 9, 6, 7, 8, 14, 21, 11, 12, 19, 10].includes(
          this.datos.datos_reclamo[0].motivo_id
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectMenu(menu) {
      this.activeBtn = menu;
      this.isMobile = false
    },
  },
};
</script>
<style lang="scss" scoped>
.pv-options-1 {
  // border-left: 2px solid #ddd;

  // height: 100vh;
}

.botonera {
  background-color: #f0f0f0;
  // padding: 20px;
  border-radius: 8px 8px 0 0;
  padding-bottom: 0;
  transition: all 0.2s ease-in-out;
  padding-top: 10px;
}

.botonera .el-button i {
  margin-right: 5px;
  // padding-left: 0;

  // float: left;
}

.botonera .el-button {
  border-radius: 0;
  border: none;
  font-family: 'Montserrat', sans-serif;
  //  text-align:left;
  font-size: 13.5px;
  // padding: 10px 0px;
  padding-bottom: 15px;
  padding-left: 0;
  background: transparent;
}

.is-active {
  // border-bottom: 4px solid #BFBE51 !important;
  color: #333 !important;
  font-weight: bold;
}

.botonera .el-button+.el-button {
  margin-left: 0;
}

.menuTab {}

@media screen and (max-width:768px) {
  .botonera .el-button {
    font-size: 12px;
    padding-top: 10px;

  }

  .botonera {

    padding: 0px 0px;
    // padding-top: 10px;

  }
}
</style>
